import { useQuery } from '@tanstack/react-query';
import { isEmpty } from 'lodash';

import { ChildInstancesDto, ParentInstancesDto } from '@app/components';
import { useFeatureFlag } from '@app/hooks';
import { makeRequest } from '@app/utils';
import { FEATURE } from '@app/constants';

interface RelatedInstanceDto {
  instances: RelatedInstance[];
}

interface RelatedInstance {
  id: string;
  title: string;
}

export const useInstanceRelationships = (
  relatedInstances: ParentInstancesDto[] | ChildInstancesDto[] = []
): RelatedInstance[] | undefined => {
  const instanceRelationshipFlag = useFeatureFlag({
    name: FEATURE.instanceRelationship,
  });

  return useQuery<RelatedInstanceDto, unknown, RelatedInstanceDto['instances']>(
    ['instancesBatch', relatedInstances],
    () =>
      makeRequest<RelatedInstanceDto>({
        url: '/opac-inventory/instances/batch',
        method: 'POST',
        data: {
          instanceIds: relatedInstances.flatMap(
            instance =>
              instance?.superInstanceId || instance?.subInstanceId || []
          ),
          fields: ['id', 'title'],
        },
      }),
    {
      enabled: !isEmpty(relatedInstances) && instanceRelationshipFlag?.isActive,
      select: ({ instances }) => instances,
    }
  ).data;
};
